import React, { useMemo } from 'react';
import StyliticsJumpLink from './StyliticsJumpLink';
import HorizontalLineSeparator from '../../components/HorizontalSeparator/HorizontalSeparator';
import useHasBundles from './HasBundlesHook';
import ModelMeasurement from '../../components/ModelMeasurement/ModelMeasurement';

const getModelMeasurementSettings = (brand) => {
  const anfBrands = ['anf', 'kids'];
  return {
    hasStyleItJumpLink: !anfBrands.includes(brand),
  };
};

export default function MeasurementsAndStyliticsOverlay({
  tmntData,
  activeProduct: { fitInformation, hasFitInfo },
  brand,
  hasPDPMFEBelowTheFold,
  isQuickview,
  isMobile,
}) {
  const { hasStyleItJumpLink } = useMemo(() => getModelMeasurementSettings(brand), [brand]);
  const hasBundles = useHasBundles();

  const shouldDisplayStyliticsLink = useMemo(() => hasBundles && hasStyleItJumpLink && !isQuickview, [hasBundles, hasStyleItJumpLink, isQuickview]);
  const shouldDisplayMeasurement = (hasFitInfo && (!isQuickview || isMobile));
  const isPdp = shouldDisplayStyliticsLink || (hasFitInfo && !isQuickview);
  const isQvMobile = isMobile && isQuickview && hasFitInfo;

  if (!hasFitInfo && !shouldDisplayStyliticsLink) return null;

  return (
    (isPdp || isQvMobile) ? (
      <div className={`measurement-and-stylitics-wrapper ${shouldDisplayMeasurement ? 'show-measurement' : ''}`} data-testid="measurement-and-stylitics-wrapper">
        {shouldDisplayMeasurement && <ModelMeasurement tmntData={tmntData} fitInformation={fitInformation} />}
        {(shouldDisplayStyliticsLink) && (
        <>
          {hasFitInfo && <HorizontalLineSeparator />}
          <StyliticsJumpLink
            tmntData={tmntData}
            activeBrand={brand}
            hasPDPMFEBelowTheFold={hasPDPMFEBelowTheFold}
            testId="stylitics-jumplink"
          />
        </>
        )}
      </div>
    ) : null
  );
}
